import script from "./VDatePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./VDatePicker.vue?vue&type=script&lang=ts&setup=true"

import "./VDatePicker.vue?vue&type=style&index=0&id=244c47d8&lang=sass"

const __exports__ = script;

export default __exports__